export default [
    {
        path: '/occurrences',
        name: 'occurrences',
        component: () => import ('./pages/Index')
    },
]